import styled from "@emotion/styled";

export const PaginationControlsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid var(--mb-color-border);
`;
